import {
  TUserActualsDB,
  TREQUEST_ToBeRectifiedListing,
  TRESPONSE_AppStateResponse,
  TRESPONSE_ToBeRectifiedListing,
  TToBeRectifiedDTO,
  TRESPONSE_RestoreToBeRectifiedCounts,
  TBctxWithMultipleSize,
  TSelectedStationIdAndShiftId,
  TRESPONSE_BusinessContextData,
  TStationDetails,
  TBulkEvent,
  TEventLocation,
  TForwardBulkEvent,
  TDefectiveResolutionActionType,
  TInputAppStore,
  TSyncEventStatus,
  TBctxItemWithoutSizeAndBctxKey,
  TRESPONSE_AppStateResponseForBackedUpBctx,
  TMDPointGradingPageAction,
  TBackgroundEventsSyncingDB,
  TSyncEventsDTO,
  TBctxChangeEventWithoutStatus,
  TBulkEventWithoutStatus,
  TUserAction,
  TUserActualsDBLockDetails,
  TBgEventsSyncingDBLockDetails,
  TEventAddtionSideActions,
  TLoadBctxSideActions,
  TRESPONSE_GET_PER_PIECE_LINE_IN_TRANSACTIONS,
  TClientDBInitInfo,
  TRestoreBackedUpBctx,
  TEventAddtionMoreActions,
  TSelectedBctxInfo,
  TLoadBctxMoreActions,
  TPerPieceQcCurrentActionInfo,
  TAppIdentifier,
  TBctxKeysToDisplayMap,
  TIncompleteBundle,
  TIncompleteBundlesInfo,
  TInputAppLoaderIdentifier,
  TBctxItemWithoutSize,
  TBctxItemWithWipTransferDetails,
  TRESPONSE_NewBctxSizeList,
  TNewBctxItemInPOSplit,
  TRESPONSE_masterdataLists,
  TLoadBctxSideActionsPlanBased,
  TMasterDataListMetaData,
  TBctxItem,
  TMemberAdditionSingleEvent,
  TSingleCountEvent,
  TReSyncEventsDayType,
  TBulkEventBackgroundData,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';

export enum InputAppClientDBActionTypes {
  AcquireLockAndThenInitializeUserAndBgDBs = 'AcquireLockAndThenInitializeUserAndBgDBs',
  InitializeUserAndBgDBsAndThenReleaseLock = 'InitializeUserAndBgDBsAndThenReleaseLock',
  InitializeReduxStore = 'InitializeReduxStore',
  InitializeReduxStoreSuccess = 'InitializeReduxStoreSuccess',
  InitializeReduxStoreFailed = 'InitializeReduxStoreFailed',
  AcquireLockAndClearSelectedBctxAndReleaseLock = 'AcquireLockAndClearSelectedBctxAndReleaseLock',
  AcquireLockAndNotifyBctxChangeAndDismissModalAndReleaseLock = 'AcquireLockAndNotifyBctxChangeAndDismissModalAndReleaseLock',
  NotifyBctxChangeAndReleaseLockAndThenDismissModal = 'NotifyBctxChangeAndReleaseLockAndThenDismissModal',
  UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent = 'UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent',
  UpdatedWipAndActuals = 'UpdatedWipAndActuals',
  SaveEvents = 'SaveEvents',
  ToBeRectifiedSaveEvents = 'ToBeRectifiedSaveEvents',
  AcquireUserDBLockAndLoadToBeRectifiedData = 'AcquireUserDBLockAndLoadToBeRectifiedData',
  LoadToBeRectifiedDataAndReleaseLock = 'LoadToBeRectifiedDataAndReleaseLock',
  UpdateToBeRectifiedDataAndReleaseLockAndThenDismissLoader = 'UpdateToBeRectifiedDataAndReleaseLockAndThenDismissLoader',
  AcquireUserDBLockAndClearToBeRectifiedList = 'AcquireUserDBLockAndClearToBeRectifiedList',
  ClearToBeRectifiedListingAndReleaseLockAndThenDismissModal = 'ClearToBeRectifiedListingAndReleaseLockAndThenDismissModal',
  RestoreToBeRectifiedCountsAndThenReleaseLock = 'RestoreToBeRectifiedCountsAndThenReleaseLock',
  AcquireLockAndRestoreToBeRectifiedCounts = 'AcquireLockAndRestoreToBeRectifiedCounts',
  SetClientDBAndReleaseLockAndThenRestoreToBeRectifiedCounts = 'SetClientDBAndReleaseLockAndThenRestoreToBeRectifiedCounts',
  SetUserDBAndReleaseLockAndThenLoadMasterdataLists = 'SetUserDBAndReleaseLockAndThenLoadMasterdataLists',
  SetUserDBAndReleaseLockAndThenEmitBctxChangeEvent = 'SetUserDBAndReleaseLockAndThenEmitBctxChangeEvent',
  RestoreToBeRectifiedCountsSuccessAndThenReleaseLock = 'RestoreToBeRectifiedCountsSuccessAndThenReleaseLock',
  UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForNewStyles = 'UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForNewStyles',
  UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForBackedUpBctx = 'UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForBackedUpBctx',
  SyncEventsAndThenReleaseBgDBLock = 'SyncEventsAndThenReleaseBgDBLock',
  reSyncPastDaysFailedEventsAndThenReleaseBgDBLock = 'reSyncPastDaysFailedEventsAndThenReleaseBgDBLock',
  reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock = 'reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock',
  updateNextEventIDandThenReleaseBgDBLock = 'updateNextEventIDandThenReleaseBgDBLock',
  updatebgDBEventsListandNextEventIdAndReleaseUserAndBgDBLock = 'updatebgDBEventsListandNextEventIdAndReleaseUserAndBgDBLock',
  UpdateUserDBAndBgDBEventListWithNextEventIdAndThenReleaseLocks = 'UpdateUserDBAndBgDBEventListWithNextEventIdAndThenReleaseLocks',
  updateNextEventIDandThenReleaseUserAndBgDBLock = 'updateNextEventIDandThenReleaseUserAndBgDBLock',
  updateActualsAndbgDBEventsListandNextEventId = 'updateActualsAndbgDBEventsListandNextEventId',
  CheckEventsValidAndThenAddBulkEvents = 'CheckEventsValidAndThenAddBulkEvents',
  ReleaseBgAndUserDbLockAndShowFailedEventsAction = 'ReleaseBgAndUserDbLockAndShowFailedEventsAction',
  AddDataToDbThenReleaseBgAndUserDbLockAndHandleSideEffects = 'AddDataToDbThenReleaseBgAndUserDbLockAndHandleSideEffects',
  UpdateBgDBAndReleaseLockForSyncEvents = 'UpdateBgDBAndReleaseLockForSyncEvents',
  UpdateBgDB = 'UpdateBgDB',
  UpdateToBeRectifiedListingAndClientDBAndReleaseLockForSyncEventsForOnlineApps = 'UpdateToBeRectifiedListingAndClientDBAndReleaseLockForSyncEventsForOnlineApps',
  UpdateUserDBAndReleaseLockForSyncEventsForOnlineApps = 'UpdateUserDBAndReleaseLockForSyncEventsForOnlineApps',
  SetUserDBAndReleaseLock = 'SetUserDBAndReleaseLock',
  SetUserDBAndClientDBAndReleaseLock = 'SetUserDBAndClientDBAndReleaseLock',
  SetUserDBAndClientDBAndReleaseLockAndEmitInitInfo = 'SetUserDBAndClientDBAndReleaseLockAndEmitInitInfo',
  SetUserDBAndBgDBAndReleaseLocksWithChains = 'SetUserDBAndBgDBAndReleaseLocksWithChains',
  SetClientDBAndReleaseLockForSyncStyleInfo = 'SetClientDBAndReleaseLockForSyncStyleInfo',
  SetClientDBAndReleaseLockForInitPending = 'SetClientDBAndReleaseLockForInitPending',
  SetClientDBAndReleaseLockForRestoreRectifiedCounts = 'SetClientDBAndReleaseLockForRestoreRectifiedCounts',
  SetClientDBAndReleaseLockForRestoreActuals = 'SetClientDBAndReleaseLockForRestoreActuals',
  RestoreAppStateAndThenReleaseLock = 'RestoreAppStateAndThenReleaseLock',
  RestoreAppStateForBackedUpBctxAndThenReleaseUserDBLock = 'RestoreAppStateForBackedUpBctxAndThenReleaseUserDBLock',
  AcquireLockAndThenRestoreActuals = 'AcquireLockAndThenRestoreActuals',
  AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx = 'AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx',
  RestoreAppStateSuccessAndThenReleaseLock = 'RestoreAppStateSuccessAndThenReleaseLock',
  RestoreAppStateSuccessForBackedUpBctxAndThenReleaseUserDBLock = 'RestoreAppStateSuccessForBackedUpBctxAndThenReleaseUserDBLock',
  SyncLocalStorageAndUpdateReduxStore = 'SyncLocalStorageAndUpdateReduxStore',
  PersistantStorageActionFailure = 'PersistantStorageActionFailure',
  InputAppNoAction = 'InputAppNoAction',
  ShowFailedEventsAction = 'ShowFailedEventsAction',
  ReleaseUserDBLockAndShowPopupAndDismissLoader = 'ReleaseUserDBLockAndShowPopupAndDismissLoader',
  CheckStationOrShiftChange = 'CheckStationOrShiftChangeAndThenReleaseLock',
  SyncStyleInfoAndThenReleaseUserDBLock = 'SyncStyleInfoAndThenReleaseUserDBLock',
  SyncStyleInfoSuccessAndThenReleaseLock = 'SyncAppStateSuccessAndThenReleaseLockAndThenRestoreActualsForNewStyles',
  AddBulkEventsAndThenReleaseUserDBLockAndThenSyncEvents = 'AddBulkEventsAndThenReleaseUserDBLockAndThenSyncEvents',
  UpdateUserDBAndThenReleaseUserDBLockAndThenSyncEvents = 'UpdateUserDBAndThenReleaseUserDBLockAndThenSyncEvents',
  UpdateUserDBAndThenReleaseUserDBLockAndThenHandleSideActions = 'UpdateUserDBAndThenReleaseUserDBLockAndThenHandleSideActions',
  ReleaseUserDBLock = 'ReleaseUserDBLock',
  ReleaseBgDBLock = 'ReleaseBgDBLock',
  AcquireUserDBLockAndValidateUndoBulkEventAndAddEvents = 'AcquireUserDBLockAndValidateUndoBulkEventAndAddEvents',
  ValidateUndoBulkEventAndReleaseLockAndThenAddEvents = 'ValidateUndoBulkEventAndReleaseLockAndThenAddEvents',
  UndoBulkEvent = 'UndoBulkEvent',
  AcquireUserDBLockAndAddBulkEvents = 'AcquireUserDBLockAndAddBulkEvents',
  AcquireUserDBLockAndHandleSideActions = 'AcquireUserDBLockAndHandleSideActions',
  AcquireUserDBLockAndHandleSideActionsAndMoreActions = 'AcquireUserDBLockAndHandleSideActionsAndMoreActions',
  AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents = 'AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents',
  SyncEventsForOnlineAppsAndReleaseLock = 'SyncEventsForOnlineAppsAndReleaseLock',
  SyncDefectiveResolutionEventsForOnlineAppsAndReleaseLock = 'SyncDefectiveResolutionEventsForOnlineAppsAndReleaseLock',
  UpdatedSelectedBctxAndReleaseLockAndThenDismissModal = 'UpdatedSelectedBctxAndReleaseLockAndThenDismissModal',
  FetchNewBctxSizeList = 'FetchNewBctxSizeList',
  AcquireLockAndFetchNewBctxSizeList = 'AcquireLockAndFetchNewBctxSizeList',
  InsertNewBctxSizeListIntoDB = 'InsertNewBctxSizeListIntoDB',
  InsertNewBctxSizeListIntoDBSuccessAndReleaseLock = 'InsertNewBctxSizeListIntoDBSuccessAndReleaseLock',
  SyncBctxChangeEventForOnlineAppsAndThenReleaseLock = 'SyncBctxChangeEventForOnlineAppsAndThenReleaseLock',
  AcquireLockAndUpdateBctxWithoutChangeEvent = 'AcquireLockAndUpdateBctxWithoutChangeEvent',
  UpdateBctxWithoutChangeEvent = 'UpdateBctxWithoutChangeEvent',
  UpdateBctxWithoutChangeEventSuccessAndReleaseLock = 'UpdateBctxWithoutChangeEventSuccessAndReleaseLock',
  AddBulkEventForOnlineApps = 'AddBulkEventForOnlineApps',
  AddDefectiveResolutionBulkEventForOnlineApps = 'AddDefectiveResolutionBulkEventForOnlineApps',
  AddBctxChangeEventForOnlineApps = 'AddBctxChangeEventForOnlineApps',
  BackUpBctxData = 'BackUpBctxData',
  UpdatePerPieceQcCurrentActionInfo = 'UpdatePerPieceQcCurrentActionInfo',
  UpdateLockDetails = 'UpdateLockDetails',
  UpdateBgDBLockDetails = 'UpdateBgDBLockDetails',
  AcquireBgDBLockAndThenSyncEvents = 'AcquireBgDBLockAndThenSyncEvents',
  AcquireUserDBLockAndFetchIncompleteBundles = 'AcquireUserDBLockAndFetchIncompleteBundles',
  FetchIncompleteBundlesAndReleaseLock = 'FetchIncompleteBundlesAndReleaseLock',
  UpdateUserDBAndReleaseLockAndSyncStyleInfo = 'UpdateUserDBAndReleaseLockAndSyncStyleInfo',
  AcquireUserDBLockAndSyncStyleInfo = 'AcquireUserDBLockAndSyncStyleInfo',
  AcquireUserDBLockAndBgDBLockAndReconcile = 'AcquireUserDBLockAndBgDBLockAndReconcile',
  ReconcileUserDBAndBgDBAndThenReleaseLocks = 'ReconcileUserDBAndBgDBAndThenReleaseLocks',
  ClearAndReFetchPerPieceLineInTransactions = 'ClearAndReFetchPerPieceLineInTransactions',
  UpdatePerPieceLineInTransactions = 'UpdatePerPieceLineInTransactions',
  ClearPerPieceLineInTransactions = 'ClearPerPieceLineInTransactions',
  AcquireUserDBLockAndUpdateIncompleteBundlesInfo = 'AcquireUserDBLockAndUpdateIncompleteBundlesInfo',
  UpdateIncompleteBundlesInfoAndReleaseLock = 'UpdateIncompleteBundlesInfoAndReleaseLock',
  PopulateLineMapForPlanBasedAndThenReleaseUserDbLock = 'PopulateLineMapForPlanBasedAndThenReleaseUserDbLock',
  AcquireUserDBLockAndPopulateLineMapForPlanBased = 'AcquireUserDBLockAndPopulateLineMapForPlanBased',
  SetUserDBAndReleaseLockAndThenFetchNewSizeList = 'SetUserDBAndReleaseLockAndThenFetchNewSizeList',
  SetUserDbAndAcquireUserDBLockAndThenRestoreActualsForBackedUpBctx = 'SetUserDbAndAcquireUserDBLockAndThenRestoreActualsForBackedUpBctx',
  AcquireUserDBLockAndSyncStyleInfoForPlanBased = 'AcquireUserDBLockAndSyncStyleInfoForPlanBased',
  SyncStyleInfoSuccessAndThenReleaseLockPlanBased = 'SyncStyleInfoSuccessAndThenReleaseLockPlanBased',
  SyncStyleInfoAndThenReleaseUserDBLockPlanBased = 'SyncStyleInfoAndThenReleaseUserDBLockPlanBased',
  AcquireLockAndUpdateFilteredSizesListInLineMap = 'AcquireLockAndUpdateFilteredSizesListInLineMap',
  CaptureSnapShotOfDbs = 'CaptureSnapShotOfDbs',
}

export class AcquireUserDBLockAndUpdateIncompleteBundlesInfo implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndUpdateIncompleteBundlesInfo;
  constructor(public incompleteBundlesInfo: TIncompleteBundlesInfo) {}
}

export class UpdateIncompleteBundlesInfoAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateIncompleteBundlesInfoAndReleaseLock;
  constructor(public inputAppClientDB: TUserActualsDB) {}
}
export class ClearAndReFetchPerPieceLineInTransactions implements Action {
  readonly type = InputAppClientDBActionTypes.ClearAndReFetchPerPieceLineInTransactions;
  constructor(public startTime: number, public endTime: number) {}
}
export class UpdatePerPieceLineInTransactions implements Action {
  readonly type = InputAppClientDBActionTypes.UpdatePerPieceLineInTransactions;
  constructor(public response: TRESPONSE_GET_PER_PIECE_LINE_IN_TRANSACTIONS) {}
}
export class ClearPerPieceLineInTransactions implements Action {
  readonly type = InputAppClientDBActionTypes.ClearPerPieceLineInTransactions;
  constructor() {}
}
export class BackUpBctxData implements Action {
  readonly type = InputAppClientDBActionTypes.BackUpBctxData;
  constructor() {}
}
export class UpdatePerPieceQcCurrentActionInfo implements Action {
  readonly type = InputAppClientDBActionTypes.UpdatePerPieceQcCurrentActionInfo;
  constructor(public currentActionInfo: TPerPieceQcCurrentActionInfo, public stationId: string) {}
}
export class AddBctxChangeEventForOnlineApps implements Action {
  readonly type = InputAppClientDBActionTypes.AddBctxChangeEventForOnlineApps;
  constructor(
    public oldBctx: TBctxItemWithoutSizeAndBctxKey, // this will be either PO2 (PO1 --> PO2) or PO1 in case of single PO
    public newBctx: TBctxItemWithoutSizeAndBctxKey, // parent bctx
    public stationId: string,
    public newBctxForPOSplit?: TNewBctxItemInPOSplit, // child bctx
  ) {}
}
export class SyncBctxChangeEventForOnlineAppsAndThenReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.SyncBctxChangeEventForOnlineAppsAndThenReleaseLock;
  constructor(
    public bulkEvent: TBulkEventWithoutStatus,
    public newBctx: TBctxItemWithoutSizeAndBctxKey,
    public stationId: string,
    public newBctxForPOSplit?: TNewBctxItemInPOSplit,
  ) {}
}

export class AcquireLockAndUpdateBctxWithoutChangeEvent implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireLockAndUpdateBctxWithoutChangeEvent;
  constructor(public bctx: TBctxItemWithoutSizeAndBctxKey, public newBctxForPOSplit?: TNewBctxItemInPOSplit) {}
}

export class UpdateBctxWithoutChangeEvent implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateBctxWithoutChangeEvent;
  constructor(public bctx: TBctxItemWithoutSizeAndBctxKey, public newBctxForPOSplit?: TNewBctxItemInPOSplit) {}
}

export class UpdateBctxWithoutChangeEventSuccessAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateBctxWithoutChangeEventSuccessAndReleaseLock;
  constructor(
    public newBctx: TSelectedBctxInfo,
    public stationId: string,
    public newBctxForPOSplit?: TNewBctxItemInPOSplit,
  ) {}
}

export class UpdatedSelectedBctxAndReleaseLockAndThenDismissModal implements Action {
  readonly type = InputAppClientDBActionTypes.UpdatedSelectedBctxAndReleaseLockAndThenDismissModal;
  constructor(public newBctx: TSelectedBctxInfo, public stationId: string, public isPPLineMapUsed: boolean) {}
}

export class AcquireLockAndFetchNewBctxSizeList implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireLockAndFetchNewBctxSizeList;
  constructor(
    public parentBctx: TBctxItemWithoutSizeAndBctxKey,
    public childBctx: TNewBctxItemInPOSplit,
    public currentSelectedBctxInfo: TSelectedBctxInfo,
  ) {}
}

export class FetchNewBctxSizeList implements Action {
  readonly type = InputAppClientDBActionTypes.FetchNewBctxSizeList;
  constructor(
    public parentBctx: TBctxItemWithoutSizeAndBctxKey,
    public childBctx: TNewBctxItemInPOSplit,
    public currentSelectedBctxInfo: TSelectedBctxInfo,
  ) {}
}

export class InsertNewBctxSizeListIntoDB implements Action {
  readonly type = InputAppClientDBActionTypes.InsertNewBctxSizeListIntoDB;
  constructor(
    public res: TRESPONSE_NewBctxSizeList,
    public parentBctx: TBctxItemWithoutSizeAndBctxKey,
    public childBctx: TNewBctxItemInPOSplit,
    public currentSelectedBctxInfo: TSelectedBctxInfo,
  ) {}
}

export class InsertNewBctxSizeListIntoDBSuccessAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.InsertNewBctxSizeListIntoDBSuccessAndReleaseLock;
  constructor(
    public currentDB: TUserActualsDB,
    public parentBctx: TBctxItemWithoutSizeAndBctxKey,
    public childBctx: TNewBctxItemInPOSplit,
    public currentSelectedBctxInfo: TSelectedBctxInfo,
  ) {}
}

export class AddBulkEventForOnlineApps implements Action {
  readonly type = InputAppClientDBActionTypes.AddBulkEventForOnlineApps;
  constructor(public bulkEvent: TBulkEventWithoutStatus) {}
}
export class SyncEventsForOnlineAppsAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.SyncEventsForOnlineAppsAndReleaseLock;
  constructor(public bulkEvent: TBulkEventWithoutStatus) {}
}
export class UpdateUserDBAndReleaseLockForSyncEventsForOnlineApps implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateUserDBAndReleaseLockForSyncEventsForOnlineApps;
  constructor(
    public currentDB: TUserActualsDB,
    public failedEventsIndexes: number[],
    public lastBatchSyncStatus: TSyncEventStatus,
    public bulkEvent: TBulkEvent,
  ) {}
}
export class AddDefectiveResolutionBulkEventForOnlineApps implements Action {
  readonly type = InputAppClientDBActionTypes.AddDefectiveResolutionBulkEventForOnlineApps;
  constructor(
    public bulkEvent: TBulkEventWithoutStatus,
    public reFetchToBeRectifiedList: TREQUEST_ToBeRectifiedListing,
  ) {}
}
export class SyncDefectiveResolutionEventsForOnlineAppsAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.SyncDefectiveResolutionEventsForOnlineAppsAndReleaseLock;
  constructor(
    public bulkEvent: TBulkEventWithoutStatus,
    public reFetchToBeRectifiedList: TREQUEST_ToBeRectifiedListing,
  ) {}
}
export class UpdateToBeRectifiedListingAndClientDBAndReleaseLockForSyncEventsForOnlineApps implements Action {
  readonly type =
    InputAppClientDBActionTypes.UpdateToBeRectifiedListingAndClientDBAndReleaseLockForSyncEventsForOnlineApps;
  constructor(
    public toBeRectifiedListing: TInputAppStore['toBeRectifiedListing'],
    public currentDB: TUserActualsDB,
    public failedEventsIndexes: number[],
    public lastBatchSyncStatus: TSyncEventStatus,
    public bulkEvent: TBulkEvent,
  ) {}
}
export class AcquireUserDBLockAndAddBulkEvents implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndAddBulkEvents;
  constructor(
    public events: TBulkEventWithoutStatus[],
    public showLoader: boolean,
    public eventAddtionMoreActions: TEventAddtionMoreActions,
    public eventAdditionSideActions?: TEventAddtionSideActions,
  ) {}
}
export class AcquireUserDBLockAndHandleSideActions implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndHandleSideActions;
  constructor(
    public eventAddtionMoreActions: TEventAddtionMoreActions,
    public eventAdditionSideActions?: TEventAddtionSideActions,
  ) {}
}
export class AcquireUserDBLockAndHandleSideActionsAndMoreActions implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndHandleSideActionsAndMoreActions;
  constructor(
    public eventAddtionMoreActions: TEventAddtionMoreActions,
    public eventAdditionSideActions?: TEventAddtionSideActions,
  ) {}
}

export class AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents;
  constructor(
    public events: TBulkEventWithoutStatus[],
    public eventAddtionMoreActions: TEventAddtionMoreActions,
    public eventAdditionSideActions?: TEventAddtionSideActions,
    public rfidScannerBulkMode: boolean = false,
  ) {}
}

export class AddBulkEventsAndThenReleaseUserDBLockAndThenSyncEvents implements Action {
  readonly type = InputAppClientDBActionTypes.AddBulkEventsAndThenReleaseUserDBLockAndThenSyncEvents;
  constructor(
    public events: TBulkEventWithoutStatus[],
    public showLoader: boolean,
    public eventAddtionMoreActions: TEventAddtionMoreActions,
    public eventAdditionSideActions?: TEventAddtionSideActions,
  ) {}
}
export class UpdateUserDBAndThenReleaseUserDBLockAndThenSyncEvents implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateUserDBAndThenReleaseUserDBLockAndThenSyncEvents;
  constructor(
    public updateActualsOnly: boolean,
    public updatedDB: TUserActualsDB,
    public addedEvents: TBulkEventWithoutStatus[],
    public eventAdditionSideActions?: TEventAddtionSideActions,
  ) {}
}
export class UpdateUserDBAndThenReleaseUserDBLockAndThenHandleSideActions implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateUserDBAndThenReleaseUserDBLockAndThenHandleSideActions;
  constructor(public updatedDB: TUserActualsDB, public eventAdditionSideActions?: TEventAddtionSideActions) {}
}
export class AcquireBgDBLockAndThenSyncEvents implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireBgDBLockAndThenSyncEvents;
  constructor(
    public updateActualsOnly: boolean,
    public showLockFailure: boolean,
    public batchCount: number,
    public chainAction?: TUserAction,
  ) {}
}
export class SyncEventsAndThenReleaseBgDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.SyncEventsAndThenReleaseBgDBLock;
  constructor(
    public updateActualsOnly: boolean,
    public showLoader: boolean,
    public batchCount: number,
    public chainAction?: TUserAction,
  ) {}
}

export class reSyncPastDaysFailedEventsAndThenReleaseBgDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.reSyncPastDaysFailedEventsAndThenReleaseBgDBLock;
  constructor(
    public events: (TSingleCountEvent | TMemberAdditionSingleEvent)[],
    public eventsDayType: TReSyncEventsDayType,
    public showLoader: boolean,
  ) {}
}

export class reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock;
  constructor(
    public events: (TSingleCountEvent | TMemberAdditionSingleEvent)[],
    public eventsDayType: TReSyncEventsDayType,
    public showLoader: boolean,
  ) {}
}

export class updateNextEventIDandThenReleaseBgDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.updateNextEventIDandThenReleaseBgDBLock;
  constructor(public nextEventID: number) {}
}

export class UpdateUserDBAndBgDBEventListWithNextEventIdAndThenReleaseLocks implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateUserDBAndBgDBEventListWithNextEventIdAndThenReleaseLocks;
  constructor(
    public updatedDB: TUserActualsDB,
    public bgDBEventsList: TBulkEventBackgroundData[],
    public nextEventID: number,
  ) {}
}

export class updateActualsAndbgDBEventsListandNextEventId implements Action {
  readonly type = InputAppClientDBActionTypes.updateActualsAndbgDBEventsListandNextEventId;
  constructor(
    public reSyncedSuccessEvents: TBulkEvent[],
    public failedCount: number,
    public reSyncStatus: TSyncEventStatus,
    public bgDBEventsList: TBulkEventBackgroundData[],
    public nextEventID: number,
  ) {}
}

export class updateNextEventIDandThenReleaseUserAndBgDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.updateNextEventIDandThenReleaseUserAndBgDBLock;
  constructor(public nextEventID: number) {}
}

export class updatebgDBEventsListandNextEventIdAndReleaseUserAndBgDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.updatebgDBEventsListandNextEventIdAndReleaseUserAndBgDBLock;
  constructor(public bgDBEventsList: TBulkEventBackgroundData[], public nextEventID: number) {}
}

export class CheckEventsValidAndThenAddBulkEvents implements Action {
  readonly type = InputAppClientDBActionTypes.CheckEventsValidAndThenAddBulkEvents;
  constructor(
    public events: TBulkEventWithoutStatus[],
    public eventAddtionMoreActions: TEventAddtionMoreActions,
    public eventAdditionSideActions?: TEventAddtionSideActions,
    public rfidScannerBulkMode: boolean = false,
  ) {}
}

export class AddDataToDbThenReleaseBgAndUserDbLockAndHandleSideEffects implements Action {
  readonly type = InputAppClientDBActionTypes.AddDataToDbThenReleaseBgAndUserDbLockAndHandleSideEffects;
  constructor(
    public events: TBulkEventWithoutStatus[],
    public syncEventsDTO: TSyncEventsDTO,
    public userDb: TUserActualsDB,
    public bgDb: TBackgroundEventsSyncingDB,
    public rfidScannerBulkMode: boolean = false,
    public updateActualsOnly: boolean,
    public eventAdditionSideActions?: TEventAddtionSideActions,
  ) {}
}
export class UpdateBgDBAndReleaseLockForSyncEvents implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateBgDBAndReleaseLockForSyncEvents;
  constructor(
    public updateActualsOnly: boolean,
    public pastEventsSynced: boolean,
    public currentDB: TBackgroundEventsSyncingDB,
    public syncEventsDTO: TSyncEventsDTO,
    public chainAction?: TUserAction,
    public rfidScannerBulkMode: boolean = false,
  ) {}
}
export class UpdateBgDB implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateBgDB;
  constructor(public currentDB: TBackgroundEventsSyncingDB) {}
}
export class SetUserDBAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.SetUserDBAndReleaseLock;
  constructor(public inputAppClientDB: TUserActualsDB, public closeModal = false) {}
}
export class SetUserDBAndClientDBAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.SetUserDBAndClientDBAndReleaseLock;
  constructor(public inputAppClientDB: TUserActualsDB, public backgroundEventsSyncingDB: TBackgroundEventsSyncingDB) {}
}
export class SetUserDBAndClientDBAndReleaseLockAndEmitInitInfo implements Action {
  readonly type = InputAppClientDBActionTypes.SetUserDBAndClientDBAndReleaseLockAndEmitInitInfo;
  constructor(
    public inputAppClientDB: TUserActualsDB,
    public backgroundEventsSyncingDB: TBackgroundEventsSyncingDB,
    public initInfo: TClientDBInitInfo,
  ) {}
}
export class SetClientDBAndReleaseLockForSyncStyleInfo implements Action {
  readonly type = InputAppClientDBActionTypes.SetClientDBAndReleaseLockForSyncStyleInfo;
  constructor(public inputAppClientDB: TUserActualsDB) {}
}
export class SetClientDBAndReleaseLockForInitPending implements Action {
  readonly type = InputAppClientDBActionTypes.SetClientDBAndReleaseLockForInitPending;
  constructor(public inputAppClientDB: TUserActualsDB) {}
}
export class SetClientDBAndReleaseLockForRestoreActuals implements Action {
  readonly type = InputAppClientDBActionTypes.SetClientDBAndReleaseLockForRestoreActuals;
  constructor(public inputAppClientDB: TUserActualsDB) {}
}
export class SetClientDBAndReleaseLockForRestoreRectifiedCounts implements Action {
  readonly type = InputAppClientDBActionTypes.SetClientDBAndReleaseLockForRestoreRectifiedCounts;
  constructor(public inputAppClientDB: TUserActualsDB) {}
}
export class UpdateLockDetails implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateLockDetails;
  constructor(public lockDetails: TUserActualsDBLockDetails) {}
}
export class UpdateBgDBLockDetails implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateBgDBLockDetails;
  constructor(public lockDetails: TBgEventsSyncingDBLockDetails) {}
}
export class InitializeUserAndBgDBsAndThenReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.InitializeUserAndBgDBsAndThenReleaseLock;
  constructor() {}
}
export class CheckStationOrShiftChange implements Action {
  readonly type = InputAppClientDBActionTypes.CheckStationOrShiftChange;
  constructor() {}
}

export class SyncStyleInfoAndThenReleaseUserDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.SyncStyleInfoAndThenReleaseUserDBLock;
  constructor(
    public hideLoader: boolean,
    public moreActions: TLoadBctxMoreActions,
    public chainActions?: TLoadBctxSideActions,
  ) {}
}
export class SyncStyleInfoSuccessAndThenReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.SyncStyleInfoSuccessAndThenReleaseLock;
  constructor(
    public businessContextData: TRESPONSE_BusinessContextData,
    public moreActions: TLoadBctxMoreActions,
    public chainActions?: TLoadBctxSideActions,
  ) {}
}
export class UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForNewStyles implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForNewStyles;
  constructor(public inputAppClientDB: TUserActualsDB, public bctxWithMultipleSizeList: TBctxWithMultipleSize[]) {}
}
export class UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForBackedUpBctx implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForBackedUpBctx;
  constructor(public inputAppClientDB: TUserActualsDB, public restoreBackedUpBctxDto: TRestoreBackedUpBctx) {}
}
export class RestoreAppStateAndThenReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.RestoreAppStateAndThenReleaseLock;
  constructor(public bctxWithMultipleSizeList: TBctxWithMultipleSize[], public wip_only: boolean = false) {}
}
export class AcquireLockAndThenRestoreActuals implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireLockAndThenRestoreActuals;
  constructor(public bctxWithMultipleSizeList: TBctxWithMultipleSize[], public wip_only: boolean = false) {}
}
export class RestoreAppStateSuccessAndThenReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.RestoreAppStateSuccessAndThenReleaseLock;
  constructor(
    public appStateResponse: TRESPONSE_AppStateResponse,
    public wip_only: boolean = true,
    public bctxWithMultipleSizeList: TBctxWithMultipleSize[] = [],
  ) {}
}
export class AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx;
  constructor(public dto: TRestoreBackedUpBctx) {}
}
export class RestoreAppStateForBackedUpBctxAndThenReleaseUserDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.RestoreAppStateForBackedUpBctxAndThenReleaseUserDBLock;
  constructor(public dto: TRestoreBackedUpBctx) {}
}
export class RestoreAppStateSuccessForBackedUpBctxAndThenReleaseUserDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.RestoreAppStateSuccessForBackedUpBctxAndThenReleaseUserDBLock;
  constructor(public appStateResponse: TRESPONSE_AppStateResponseForBackedUpBctx, public dto: TRestoreBackedUpBctx) {}
}
export class InitializeReduxStore implements Action {
  readonly type = InputAppClientDBActionTypes.InitializeReduxStore;
  constructor() {}
}
export class AcquireUserDBLockAndFetchIncompleteBundles implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndFetchIncompleteBundles;
  constructor(
    public chainActions: {
      chainWithBctxSync?: {
        hideLoader: boolean;
        moreActions: TLoadBctxMoreActions;
        chainActions?: TLoadBctxSideActions;
      };
      chainWithLineOrShiftChange?: boolean;
    },
  ) {}
}

export class FetchIncompleteBundlesAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.FetchIncompleteBundlesAndReleaseLock;
  constructor(
    public chainActions: {
      chainWithBctxSync?: {
        hideLoader: boolean;
        moreActions: TLoadBctxMoreActions;
        chainActions?: TLoadBctxSideActions;
      };
      chainWithLineOrShiftChange?: boolean;
    },
  ) {}
}
export class UpdateUserDBAndReleaseLockAndSyncStyleInfo implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateUserDBAndReleaseLockAndSyncStyleInfo;
  constructor(
    public inputAppClientDB: TUserActualsDB,
    public chainActions: {
      chainWithBctxSync?: {
        hideLoader: boolean;
        moreActions: TLoadBctxMoreActions;
        chainActions?: TLoadBctxSideActions;
      };
      chainWithLineOrShiftChange?: boolean;
    },
  ) {}
}
export class AcquireUserDBLockAndSyncStyleInfo implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndSyncStyleInfo;
  constructor(
    public hideLoader: boolean,
    public moreActions: TLoadBctxMoreActions,
    public chainActions?: TLoadBctxSideActions,
  ) {}
}
export class AcquireUserDBLockAndBgDBLockAndReconcile implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndBgDBLockAndReconcile;
  constructor(public updateActualsOnly: boolean, public showLockFailure: boolean, public chainAction: TUserAction) {}
}
export class ReconcileUserDBAndBgDBAndThenReleaseLocks implements Action {
  readonly type = InputAppClientDBActionTypes.ReconcileUserDBAndBgDBAndThenReleaseLocks;
  constructor(public updateActualsOnly: boolean, public chainAction: TUserAction) {}
}
export class SetUserDBAndBgDBAndReleaseLocksWithChains implements Action {
  readonly type = InputAppClientDBActionTypes.SetUserDBAndBgDBAndReleaseLocksWithChains;
  constructor(
    public updateActualsOnly: boolean,
    public inputAppClientDB: TUserActualsDB,
    public backgroundEventsSyncingDB: TBackgroundEventsSyncingDB,
    public chainAction: TUserAction,
  ) {}
}
export class InitializeReduxStoreSuccess implements Action {
  readonly type = InputAppClientDBActionTypes.InitializeReduxStoreSuccess;
  constructor(public inputAppClientDB: TUserActualsDB) {}
}
export class InitializeReduxStoreFailed implements Action {
  readonly type = InputAppClientDBActionTypes.InitializeReduxStoreFailed;
  constructor() {}
}
export class UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent;
  constructor(
    public newBctx: TSelectedBctxInfo,
    public bulkEvent: TBctxChangeEventWithoutStatus,
    public stationId: string,
  ) {}
}
export class AcquireLockAndNotifyBctxChangeAndDismissModalAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireLockAndNotifyBctxChangeAndDismissModalAndReleaseLock;
  constructor(public payload: TSelectedBctxInfo, public dismissModal: boolean) {}
}
export class AcquireLockAndClearSelectedBctxAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireLockAndClearSelectedBctxAndReleaseLock;
  constructor() {}
}
export class NotifyBctxChangeAndReleaseLockAndThenDismissModal implements Action {
  readonly type = InputAppClientDBActionTypes.NotifyBctxChangeAndReleaseLockAndThenDismissModal;
  constructor(public payload: TSelectedBctxInfo, public dismissModal: boolean) {}
}
export class SaveEvents implements Action {
  readonly type = InputAppClientDBActionTypes.SaveEvents;
  constructor(public actionType: TMDPointGradingPageAction) {}
}
export class ToBeRectifiedSaveEvents implements Action {
  readonly type = InputAppClientDBActionTypes.ToBeRectifiedSaveEvents;
  constructor(
    public actionType: TDefectiveResolutionActionType,
    public toBeRectifiedItems: TToBeRectifiedDTO[],
    public filters: TREQUEST_ToBeRectifiedListing['filters'],
    public paginationInfo: TUserPaginationOption,
  ) {}
}
export class UpdatedWipAndActuals implements Action {
  readonly type = InputAppClientDBActionTypes.UpdatedWipAndActuals;
  constructor(
    public sizeName: string,
    public actionType: TMDPointGradingPageAction,
    public selectedBctx: TSelectedBctxInfo,
    public selectedStationIdAndShiftId: TSelectedStationIdAndShiftId,
    public count: number,
    public undo: boolean,
  ) {}
}
export class SyncLocalStorageAndUpdateReduxStore implements Action {
  readonly type = InputAppClientDBActionTypes.SyncLocalStorageAndUpdateReduxStore;
  constructor(public payload: TUserActualsDB) {}
}
export class SyncLocalStorageAndUpdateReduxStoreFailed implements Action {
  readonly type = InputAppClientDBActionTypes.SyncLocalStorageAndUpdateReduxStore;
  constructor() {}
}
export class PersistantStorageActionFailure implements Action {
  readonly type = InputAppClientDBActionTypes.PersistantStorageActionFailure;
  constructor() {}
}
export class InputAppNoAction implements Action {
  readonly type = InputAppClientDBActionTypes.InputAppNoAction;
  constructor() {}
}

export class ShowFailedEventsAction implements Action {
  readonly type = InputAppClientDBActionTypes.ShowFailedEventsAction;
  constructor(
    public appIdentifier: TAppIdentifier | false,
    public updateActualsOnly: boolean,
    public bulkEvents: TBulkEvent[],
    public failedBulkEventsIndexes: number[],
    public bctxKeysToDisplayMap: TBctxKeysToDisplayMap,
    public rfidScannerBulkMode: boolean = false,
  ) {}
}
export class ReleaseBgAndUserDbLockAndShowFailedEventsAction implements Action {
  readonly type = InputAppClientDBActionTypes.ReleaseBgAndUserDbLockAndShowFailedEventsAction;
  constructor(
    public userDb: TUserActualsDB,
    public bgDb: TBackgroundEventsSyncingDB,
    public appIdentifier: TAppIdentifier | false,
    public updateActualsOnly: boolean,
    public bulkEvents: TBulkEvent[],
    public failedBulkEventsIndexes: number[],
    public bctxKeysToDisplayMap: TBctxKeysToDisplayMap,
    public rfidScannerBulkMode: boolean = false,
  ) {}
}
export class ReleaseUserDBLockAndShowPopupAndDismissLoader implements Action {
  readonly type = InputAppClientDBActionTypes.ReleaseUserDBLockAndShowPopupAndDismissLoader;
  constructor(public title: string, public message: string, public id: TInputAppLoaderIdentifier) {}
}
export class ReleaseUserDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.ReleaseUserDBLock;
  constructor() {}
}
export class ReleaseBgDBLock implements Action {
  readonly type = InputAppClientDBActionTypes.ReleaseBgDBLock;
  constructor() {}
}
export class AcquireUserDBLockAndLoadToBeRectifiedData implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndLoadToBeRectifiedData;
  constructor(public filters: TREQUEST_ToBeRectifiedListing['filters'], public paginationInfo: TUserPaginationOption) {}
}
export class LoadToBeRectifiedDataAndReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.LoadToBeRectifiedDataAndReleaseLock;
  constructor(public filters: TREQUEST_ToBeRectifiedListing['filters'], public paginationInfo: TUserPaginationOption) {}
}
export class UpdateToBeRectifiedDataAndReleaseLockAndThenDismissLoader implements Action {
  readonly type = InputAppClientDBActionTypes.UpdateToBeRectifiedDataAndReleaseLockAndThenDismissLoader;
  constructor(public payload: TRESPONSE_ToBeRectifiedListing) {}
}
export class SetClientDBAndReleaseLockAndThenRestoreToBeRectifiedCounts implements Action {
  readonly type = InputAppClientDBActionTypes.SetClientDBAndReleaseLockAndThenRestoreToBeRectifiedCounts;
  constructor(public inputAppClientDB: TUserActualsDB, public bctxWithMultipleSizeList: TBctxWithMultipleSize[]) {}
}
export class SetUserDBAndReleaseLockAndThenLoadMasterdataLists implements Action {
  readonly type = InputAppClientDBActionTypes.SetUserDBAndReleaseLockAndThenLoadMasterdataLists;
  constructor(public inputAppClientDB: TUserActualsDB, public masterDataListMetaData: TMasterDataListMetaData) {}
}
export class SetUserDBAndReleaseLockAndThenEmitBctxChangeEvent implements Action {
  readonly type = InputAppClientDBActionTypes.SetUserDBAndReleaseLockAndThenEmitBctxChangeEvent;
  constructor(public inputAppClientDB: TUserActualsDB) {}
}
export class RestoreToBeRectifiedCountsAndThenReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.RestoreToBeRectifiedCountsAndThenReleaseLock;
  constructor(public bctxWithMultipleSizeList: TBctxWithMultipleSize[]) {}
}
export class AcquireLockAndRestoreToBeRectifiedCounts implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireLockAndRestoreToBeRectifiedCounts;
  constructor(public bctxWithMultipleSizeList: TBctxWithMultipleSize[]) {}
}
export class RestoreToBeRectifiedCountsSuccessAndThenReleaseLock implements Action {
  readonly type = InputAppClientDBActionTypes.RestoreToBeRectifiedCountsSuccessAndThenReleaseLock;
  constructor(public response: TRESPONSE_RestoreToBeRectifiedCounts, public stationDetails: TStationDetails) {}
}
export class AcquireUserDBLockAndClearToBeRectifiedList implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndClearToBeRectifiedList;
  constructor() {}
}
export class ClearToBeRectifiedListingAndReleaseLockAndThenDismissModal implements Action {
  readonly type = InputAppClientDBActionTypes.ClearToBeRectifiedListingAndReleaseLockAndThenDismissModal;
  constructor() {}
}

export class AcquireLockAndThenInitializeUserAndBgDBs implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireLockAndThenInitializeUserAndBgDBs;
  constructor() {}
}

export class AcquireUserDBLockAndValidateUndoBulkEventAndAddEvents implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndValidateUndoBulkEventAndAddEvents;
  constructor(
    public bulkEvent: TForwardBulkEvent,
    public eventAdditionMoreActions: TEventAddtionMoreActions,
    public location: TEventLocation,
    public poSplitUndoWipOverrideDetails?: TBctxItem[],
  ) {}
}

export class ValidateUndoBulkEventAndReleaseLockAndThenAddEvents implements Action {
  readonly type = InputAppClientDBActionTypes.ValidateUndoBulkEventAndReleaseLockAndThenAddEvents;
  constructor(
    public bulkEvent: TForwardBulkEvent,
    public eventAdditionMoreActions: TEventAddtionMoreActions,
    public location: TEventLocation,
    public poSplitUndoWipOverrideDetails?: TBctxItem[],
  ) {}
}

export class UndoBulkEvent implements Action {
  readonly type = InputAppClientDBActionTypes.UndoBulkEvent;
  constructor(
    public bulkEvent: TForwardBulkEvent,
    public eventAdditionMoreActions: TEventAddtionMoreActions,
    public location: TEventLocation,
    public poSplitUndoWipOverrideDetails?: TBctxItem[],
  ) {}
}

export class AcquireUserDBLockAndSyncStyleInfoForPlanBased implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndSyncStyleInfoForPlanBased;
  constructor(public chainActions: TLoadBctxSideActionsPlanBased) {}
}

export class SyncStyleInfoAndThenReleaseUserDBLockPlanBased implements Action {
  readonly type = InputAppClientDBActionTypes.SyncStyleInfoAndThenReleaseUserDBLockPlanBased;
  constructor(public chainActions: TLoadBctxSideActionsPlanBased) {}
}
export class SyncStyleInfoSuccessAndThenReleaseLockPlanBased implements Action {
  readonly type = InputAppClientDBActionTypes.SyncStyleInfoSuccessAndThenReleaseLockPlanBased;
  constructor(
    public businessContextData: TRESPONSE_BusinessContextData,
    public chainActions?: TLoadBctxSideActionsPlanBased,
  ) {}
}

export class SetUserDBAndReleaseLockAndThenFetchNewSizeList implements Action {
  readonly type = InputAppClientDBActionTypes.SetUserDBAndReleaseLockAndThenFetchNewSizeList;
  constructor(public inputAppClientDB: TUserActualsDB) {}
}

export class PopulateLineMapForPlanBasedAndThenReleaseUserDbLock implements Action {
  readonly type = InputAppClientDBActionTypes.PopulateLineMapForPlanBasedAndThenReleaseUserDbLock;
  constructor(public masterDataListMetaData: TMasterDataListMetaData) {}
}

export class AcquireUserDBLockAndPopulateLineMapForPlanBased implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireUserDBLockAndPopulateLineMapForPlanBased;
  constructor(public masterDataListMetaData: TMasterDataListMetaData) {}
}
export class SetUserDbAndAcquireUserDBLockAndThenRestoreActualsForBackedUpBctx implements Action {
  readonly type = InputAppClientDBActionTypes.SetUserDbAndAcquireUserDBLockAndThenRestoreActualsForBackedUpBctx;
  constructor(public inputAppClientDB: TUserActualsDB) {}
}

export class AcquireLockAndUpdateFilteredSizesListInLineMap implements Action {
  readonly type = InputAppClientDBActionTypes.AcquireLockAndUpdateFilteredSizesListInLineMap;
  constructor(public filteredSizesList: string[]) {}
}

export class CaptureSnapShotOfDbs implements Action {
  readonly type = InputAppClientDBActionTypes.CaptureSnapShotOfDbs;
  constructor(public origin: string) {}
}

export type TInputAppActions =
  | AddBulkEventsAndThenReleaseUserDBLockAndThenSyncEvents
  | UpdateUserDBAndThenReleaseUserDBLockAndThenSyncEvents
  | UpdateUserDBAndThenReleaseUserDBLockAndThenHandleSideActions
  | SyncEventsAndThenReleaseBgDBLock
  | reSyncPastDaysFailedEventsAndThenReleaseBgDBLock
  | reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock
  | updateNextEventIDandThenReleaseBgDBLock
  | updateNextEventIDandThenReleaseUserAndBgDBLock
  | updatebgDBEventsListandNextEventIdAndReleaseUserAndBgDBLock
  | UpdateUserDBAndBgDBEventListWithNextEventIdAndThenReleaseLocks
  | updateActualsAndbgDBEventsListandNextEventId
  | InitializeUserAndBgDBsAndThenReleaseLock
  | SyncStyleInfoAndThenReleaseUserDBLock
  | SyncStyleInfoSuccessAndThenReleaseLock
  | NotifyBctxChangeAndReleaseLockAndThenDismissModal
  | UpdatedWipAndActuals
  | UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForNewStyles
  | RestoreAppStateAndThenReleaseLock
  | RestoreAppStateSuccessAndThenReleaseLock
  | SyncLocalStorageAndUpdateReduxStore
  | InitializeReduxStore
  | InitializeReduxStoreSuccess
  | InitializeReduxStoreFailed
  | ReleaseUserDBLockAndShowPopupAndDismissLoader
  | UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent
  | PersistantStorageActionFailure
  | InputAppNoAction
  | CheckStationOrShiftChange
  | LoadToBeRectifiedDataAndReleaseLock
  | UpdateToBeRectifiedDataAndReleaseLockAndThenDismissLoader
  | ClearToBeRectifiedListingAndReleaseLockAndThenDismissModal
  | ToBeRectifiedSaveEvents
  | RestoreToBeRectifiedCountsAndThenReleaseLock
  | RestoreToBeRectifiedCountsSuccessAndThenReleaseLock
  | AcquireUserDBLockAndAddBulkEvents
  | AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents
  | CheckEventsValidAndThenAddBulkEvents
  | ReleaseBgAndUserDbLockAndShowFailedEventsAction
  | AddDataToDbThenReleaseBgAndUserDbLockAndHandleSideEffects
  | ValidateUndoBulkEventAndReleaseLockAndThenAddEvents
  | AddBulkEventForOnlineApps
  | UpdateLockDetails
  | UpdateBgDBLockDetails
  | SetUserDBAndReleaseLock
  | ReleaseUserDBLock
  | ReleaseBgDBLock
  | UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForNewStyles
  | SetClientDBAndReleaseLockAndThenRestoreToBeRectifiedCounts
  | SetUserDBAndReleaseLockAndThenLoadMasterdataLists
  | SetUserDBAndReleaseLockAndThenEmitBctxChangeEvent
  | UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForBackedUpBctx
  | UpdateToBeRectifiedListingAndClientDBAndReleaseLockForSyncEventsForOnlineApps
  | UpdateUserDBAndReleaseLockForSyncEventsForOnlineApps
  | UpdatedSelectedBctxAndReleaseLockAndThenDismissModal
  | AcquireLockAndUpdateBctxWithoutChangeEvent
  | UpdateBctxWithoutChangeEvent
  | UpdateBctxWithoutChangeEventSuccessAndReleaseLock
  | FetchNewBctxSizeList
  | AcquireLockAndFetchNewBctxSizeList
  | InsertNewBctxSizeListIntoDB
  | InsertNewBctxSizeListIntoDBSuccessAndReleaseLock
  | SetUserDBAndClientDBAndReleaseLock
  | UpdateBgDBAndReleaseLockForSyncEvents
  | UpdateBgDB
  | SetUserDBAndBgDBAndReleaseLocksWithChains
  | UpdatePerPieceLineInTransactions
  | ClearPerPieceLineInTransactions
  | ClearAndReFetchPerPieceLineInTransactions
  | SetUserDBAndClientDBAndReleaseLockAndEmitInitInfo
  | UpdatePerPieceQcCurrentActionInfo
  | UpdateUserDBAndReleaseLockAndSyncStyleInfo
  | UpdateIncompleteBundlesInfoAndReleaseLock
  | UndoBulkEvent
  | AcquireUserDBLockAndSyncStyleInfoForPlanBased
  | SyncStyleInfoAndThenReleaseUserDBLockPlanBased
  | SyncStyleInfoSuccessAndThenReleaseLockPlanBased
  | SetUserDBAndReleaseLockAndThenFetchNewSizeList
  | PopulateLineMapForPlanBasedAndThenReleaseUserDbLock
  | AcquireUserDBLockAndPopulateLineMapForPlanBased
  | SetUserDbAndAcquireUserDBLockAndThenRestoreActualsForBackedUpBctx
  | AcquireLockAndUpdateFilteredSizesListInLineMap
  | CaptureSnapShotOfDbs;
